//#region Imports
import { drawArrow, drawTapArrow } from "../draw/draw.js";
import {
  getMouse3dDirection,
  updateToothBeforeMove,
  rotateAroundAxisY,
  rotateAroundAxisZ,
  rotateAroundAxisX,
  rotateAboutPoint,
} from "../geometry/editObject";
import {
  rotatePoint2D,
  getPointHonBC,
  getPointB,
  calculateDistance2D,
} from "@/components/geometry/geometry.js";
import {
  prepareLaplacianDeform,
  applyRotateToGingiva,
  applyMoveToGingiva,
} from "@/components/geometry/gingivaHelper.js";
import {
  ioViewer,
  ioPlane,
  ioRaycaster,
  getIoMouse3dDirection,
  gingivae as ioGingivae,
} from "@/components/intraoral/IntraoralManager";
import { drawMoveRotateGroup } from "../draw/toothHelper.js";
import {
  findToothCollisions,
  findToothAnchorageLoss,
} from "@/components/ortho/OrthoPlanMode.js";
//#endregion

const radius = 140; // 14

let offset = new THREE.Vector3();
let movedMesh = null;
let crossedMesh = null;
let movedControlMesh = null;
let needUpdate = false;
let clickPoint = new THREE.Vector3();
let normal = new THREE.Vector3();
let rotateAxis = null;
let updateTime = null;
let orthoViewer = null;
let orthoPlane = null;
let orthoRaycaster = null;

let moveContext = {
  id: null,
  editedObject: null,
  tooth: null,
  isVerticalPlane: false,
  angle: 0,
  moveLine: null,
  fromTapArrow: null,
  toTapArrow: null,
  from: null,
  to: null,
};

function enterMoveMode(editedObject) {
  orthoViewer = vueApp.isIntraoralView ? ioViewer : viewer;
  orthoPlane = vueApp.isIntraoralView ? ioPlane : implantPlane;
  orthoRaycaster = vueApp.isIntraoralView ? ioRaycaster : raycaster;

  moveContext.editedObject = editedObject;
  if (editedObject) {
    editedObject.isMoved = true;
    editedObject.isRotated = editedObject.isResized = false;
    moveContext.id = editedObject.id;
    moveContext.tooth = editedObject.tooth;
    moveContext.angle = editedObject.sliderValue * Math.PI;
  } else {
    moveContext.id = moveContext.tooth = moveContext.angle = null;
  }

  redrawMoveArrow();
}

function exitMoveMode() {
  moveContext.id = null;
  if (moveContext.moveLine) {
    orthoViewer.scene.remove(moveContext.moveLine);
    if (moveContext.fromTapArrow) {
      orthoViewer.scene.remove(moveContext.fromTapArrow);
      orthoViewer.scene.remove(moveContext.toTapArrow);
    }
  }
}

function redrawMoveArrow() {
  if (moveContext.moveLine) {
    orthoViewer.scene.remove(moveContext.moveLine);
    // moveContext.moveLine = null;
  }
  if (crossedMesh) {
    orthoViewer.scene.remove(crossedMesh);
    // crossedMesh = null;
  }
  if (moveContext.fromTapArrow) {
    orthoViewer.scene.remove(moveContext.fromTapArrow);
    orthoViewer.scene.remove(moveContext.toTapArrow);
  }

  if (moveContext.editedObject && moveContext.tooth) {
    var tooth = moveContext.tooth;
    var mesh = orthoViewer.get_model_mesh(moveContext.id);
    orthoPlane.position.copy(mesh.position);
    orthoPlane.lookAt(orthoViewer.camera.position);

    var center = mesh.position;
    var min = {
      x: tooth.defaultBox.min.x + (center.x - tooth.defaultPosition.x),
      y: tooth.defaultBox.min.y + (center.y - tooth.defaultPosition.y),
      z: tooth.defaultBox.min.z + (center.z - tooth.defaultPosition.z),
    };
    var max = {
      x: tooth.defaultBox.max.x + (center.x - tooth.defaultPosition.x),
      y: tooth.defaultBox.max.y + (center.y - tooth.defaultPosition.y),
      z: tooth.defaultBox.max.z + (center.z - tooth.defaultPosition.z),
    };

    var dy = Math.abs(max.y - min.y);

    center = {
      x: center.x,
      y: tooth.isMaxilla ? center.y - dy / 6 : center.y + dy / 6,
      z: center.z,
    };

    var from = moveContext.isVerticalPlane
      ? { x: center.x, y: center.y - radius, z: center.z }
      : { x: center.x - radius, y: center.y, z: center.z };
    var to = moveContext.isVerticalPlane
      ? { x: center.x, y: center.y + radius, z: center.z }
      : { x: center.x + radius, y: center.y, z: center.z };

    var difx = 5;
    var dify = 3;
    var mfrom = moveContext.isVerticalPlane
      ? { x: from.x + difx, y: from.y, z: from.z }
      : { x: from.x, y: from.y - dify, z: from.z };
    var mto = moveContext.isVerticalPlane
      ? { x: to.x + difx, y: to.y, z: to.z }
      : { x: to.x, y: to.y - dify, z: to.z };

    if (moveContext.angle != 0) {
      if (moveContext.isVerticalPlane) {
        var rfrom = rotatePoint2D(center, moveContext.angle, from);
        from.x = rfrom.x;
        from.y = rfrom.y;
        var rto = rotatePoint2D(center, moveContext.angle, to);
        to.x = rto.x;
        to.y = rto.y;

        rfrom = rotatePoint2D(center, moveContext.angle, mfrom);
        mfrom.x = rfrom.x;
        mfrom.y = rfrom.y;
        rto = rotatePoint2D(center, moveContext.angle, mto);
        mto.x = rto.x;
        mto.y = rto.y;
      } else {
        var rfrom = rotatePoint2D(
          { x: center.x, y: center.z },
          moveContext.angle,
          { x: from.x, y: from.z }
        );
        from.x = rfrom.x;
        from.z = rfrom.y;
        var rto = rotatePoint2D(
          { x: center.x, y: center.z },
          moveContext.angle,
          { x: to.x, y: to.z }
        );
        to.x = rto.x;
        to.z = rto.y;

        rfrom = rotatePoint2D({ x: center.x, y: center.z }, moveContext.angle, {
          x: mfrom.x,
          y: mfrom.z,
        });
        mfrom.x = rfrom.x;
        mfrom.z = rfrom.y;
        rto = rotatePoint2D({ x: center.x, y: center.z }, moveContext.angle, {
          x: mto.x,
          y: mto.z,
        });
        mto.x = rto.x;
        mto.z = rto.y;
      }
    }

    from = new THREE.Vector3(from.x, from.y, from.z);
    to = new THREE.Vector3(to.x, to.y, to.z);
    mfrom = new THREE.Vector3(mfrom.x, mfrom.y, mfrom.z);
    mto = new THREE.Vector3(mto.x, mto.y, mto.z);

    let groupCenter = new THREE.Vector3(
      mesh.position.x,
      mesh.position.y,
      mesh.position.z
    );
    if (vueApp.isIntraoralView) {
      let dcenter = tooth.defaultBox.center;
      groupCenter.set(
        groupCenter.x + dcenter.x,
        groupCenter.y + dcenter.y,
        groupCenter.z + dcenter.z
      );
    }
    moveContext.moveLine = drawMoveRotateGroup(mesh, orthoViewer, groupCenter);
    moveContext.moveLine.visible = true;

    let gingivae = vueApp.isIntraoralView ? ioGingivae : vueApp.gingivae;
    prepareLaplacianDeform(orthoViewer, moveContext.tooth, mesh, gingivae);

    // moveContext.moveLine = drawArrow(from, to);
    if (moveContext.editedObject.showTapArrows) {
      moveContext.fromTapArrow = drawTapArrow(
        mfrom,
        false,
        moveContext.isVerticalPlane,
        moveContext.angle,
        "from",
        true
      );
      moveContext.toTapArrow = drawTapArrow(
        mto,
        true,
        moveContext.isVerticalPlane,
        moveContext.angle,
        "to",
        true
      );
    }

    moveContext.from = new THREE.Vector3(
      from.x,
      tooth.isMaxilla ? from.y + dy / 6 : from.y - dy / 6,
      from.z
    );
    moveContext.to = new THREE.Vector3(
      to.x,
      tooth.isMaxilla ? to.y + dy / 6 : to.y - dy / 6,
      to.z
    );
    moveContext.center = new THREE.Vector3(center.x, center.y, center.z);
  }
}

// OBSOLETE
function moveModeMouseDown(tooth, event) {
  if (tooth && tooth.id == moveContext.id) {
    // mesh = orthoViewer.get_model_mesh(tooth.id);
    // if (mesh) {
    //   orthoViewer.controls.enabled = false;
    //   orthoPlane.position.copy(mesh.position);
    //   orthoPlane.lookAt(orthoViewer.camera.position);
    //   var intersects = orthoRaycaster.intersectObject(orthoPlane);
    //   offset.copy(intersects[0].point).sub(orthoPlane.position);
    // }
  } else {
    movedMesh = null;
  }
}

// MOVE&ROTATE control or tooth
function moveModeTagDetected(tag, tagMesh, isShift, intersectPoint) {
  updateTime = window.performance.now();
  console.log("moveModeTagDetected", tag, isShift);
  if (isShift) {
    moveTaggedControl(tag, tagMesh, intersectPoint);
  } else {
    moveToothByTag(tag, tagMesh, intersectPoint);
  }
}

// SHIFT LOGIC
function moveTaggedControl(tag, tagMesh, intersectPoint) {
  movedControlMesh = tagMesh ? tagMesh.parent : null;
  if (movedControlMesh && moveContext.id) {
    orthoViewer.controls.enabled = false;

    // let tempMesh = orthoViewer.get_model_mesh(moveContext.id);
    let center = (moveContext.center = movedControlMesh.position);
    //  tempMesh.position);
    moveContext.tag = tag;
    moveContext.isRotated =
      tag === "zRotateRing" || tag === "yRotateRing" || tag === "xRotateRing";

    normal.copy(orthoViewer.camera.position).sub(center);
    orthoPlane.position.copy(center);
    orthoPlane.lookAt(orthoViewer.camera.position);
    var intersects = orthoRaycaster.intersectObject(orthoPlane);
    clickPoint.copy(intersects[0].point);
    offset.copy(intersects[0].point).sub(orthoPlane.position);

    if (moveContext.isRotated) {
      rotateAxis = new THREE.Vector3();
      let rotateRadius = 18;
      let viewPoint = orthoViewer.camera.position;

      let rotateStart = null;
      if (tag == "xRotateRing") {
        // redRing
        if (viewPoint && viewPoint.x < center.x) {
          rotateRadius = -rotateRadius;
        }
        rotateStart = new THREE.Vector3(rotateRadius, 0, 0);
      }
      if (tag == "yRotateRing") {
        // blueRing
        if (viewPoint && viewPoint.y < center.y) {
          rotateRadius = -rotateRadius;
        }
        rotateStart = new THREE.Vector3(0, rotateRadius, 0);
      } else if (tag == "zRotateRing") {
        // greenRing
        if (viewPoint && viewPoint.z < center.z) {
          rotateRadius = -rotateRadius;
        }
        rotateStart = new THREE.Vector3(0, 0, rotateRadius);
      }
      let rotateEnd = new THREE.Vector3(0, 0, 0);
      rotateAxis.subVectors(rotateStart, rotateEnd).normalize();
    }
  }
  // console.log("movedControlMesh", movedControlMesh);
}

// TOOTH MOVE&ROTATE
function moveToothByTag(tag, tagMesh, intersectPoint) {
  if (moveContext.id) {
    movedMesh = orthoViewer.get_model_mesh(moveContext.id);

    if (movedMesh && tag && tagMesh) {
      orthoViewer.controls.enabled = false;

      let movedControlGroup = tagMesh.parent;
      let center = (moveContext.center = movedControlGroup.position); // movedMesh.position;
      let boxMatrix = movedControlGroup.matrixWorld;
      movedMesh.subvector = movedControlGroup.position
        .clone()
        .sub(movedMesh.position);

      normal.copy(orthoViewer.camera.position).sub(center);
      orthoPlane.position.copy(center);
      orthoPlane.lookAt(orthoViewer.camera.position);
      var intersects = orthoRaycaster.intersectObject(orthoPlane);
      if (!intersects || !intersects.length) {
        movedMesh = null;
        return;
      }
      clickPoint.copy(intersects[0].point);
      offset.copy(intersects[0].point).sub(orthoPlane.position);

      moveContext.tag = tag;
      moveContext.isRotated = false;

      let tagGeometry = movedMesh.geometry; //tagMesh.geometry;
      if (!tagGeometry.boundingBox) {
        tagGeometry.computeBoundingBox();
      }
      // let box = offsetBox(tagGeometry.boundingBox, 0, 0, 0);
      if (tag == "xMoveArrow") {
        moveContext.from = new THREE.Vector3(-radius, 0, 0);
        moveContext.to = new THREE.Vector3(radius, 0, 0);
        moveContext.from.applyMatrix4(boxMatrix);
        moveContext.to.applyMatrix4(boxMatrix);
      } else if (tag == "yMoveArrow") {
        moveContext.from = new THREE.Vector3(0, -radius, 0);
        moveContext.to = new THREE.Vector3(0, radius, 0);
        moveContext.from.applyMatrix4(boxMatrix);
        moveContext.to.applyMatrix4(boxMatrix);
      } else if (tag == "zMoveArrow") {
        moveContext.from = new THREE.Vector3(0, 0, -radius);
        moveContext.to = new THREE.Vector3(0, 0, radius);
        moveContext.from.applyMatrix4(boxMatrix);
        moveContext.to.applyMatrix4(boxMatrix);
      } else {
        moveContext.isRotated = true;
        rotateAxis = new THREE.Vector3();
        let rotateRadius = 18;
        let viewPoint = orthoViewer.camera.position;
        if (tag == "xRotateRing") {
          // redRing
          if (viewPoint && viewPoint.x < center.x) {
            rotateRadius = -rotateRadius;
          }
          moveContext.to = new THREE.Vector3(rotateRadius, 0, 0);
        } else if (tag == "yRotateRing") {
          // blueRing
          if (viewPoint && viewPoint.y < center.y) {
            rotateRadius = -rotateRadius;
          }
          moveContext.to = new THREE.Vector3(0, rotateRadius, 0);
        } else if (tag == "zRotateRing") {
          // greenRing
          if (viewPoint && viewPoint.z < center.z) {
            rotateRadius = -rotateRadius;
          }
          moveContext.to = new THREE.Vector3(0, 0, rotateRadius);
        }
        moveContext.to.applyMatrix4(boxMatrix);

        let start = moveContext.to;
        let end = moveContext.center;

        rotateAxis.subVectors(start, end).normalize();
      }
    }
  } else {
    movedMesh = null;
  }
}

function moveModeMouseMove(event) {
  let deltaTime = window.performance.now() - updateTime;
  if ((movedMesh || movedControlMesh) && deltaTime > 20) {
    updateTime = window.performance.now();
    if (event.preventDefault) event.preventDefault();

    var direction = vueApp.isIntraoralView
      ? getIoMouse3dDirection(event)
      : getMouse3dDirection(event);
    if (!direction) return;

    orthoRaycaster.set(orthoViewer.camera.position, direction);

    var intersects = orthoRaycaster.intersectObject(orthoPlane);
    if (intersects.length > 0) {
      if (moveContext.isRotated) {
        var mousePoint = intersects[0].point;
        var rotateCenter = moveContext.center;
        var v1 = new THREE.Vector3();
        v1.copy(clickPoint).sub(rotateCenter);

        var v2 = new THREE.Vector3();
        v2.copy(mousePoint).sub(rotateCenter);

        var angle = v1.angleTo(v2);
        var cross = v1.cross(v2);
        var temp = normal.clone().dot(cross);
        // console.log(
        //   "moveContext.isRotated",
        //   moveContext.tag,
        //   angle,
        //   temp,
        //   rotateAxis
        // );
        angle /= 2;
        if (temp < 0) {
          angle = 2 * Math.PI - angle;
        }
      }
      // console.log("moveContext.isRotated", moveContext.tag, angle);
      // console.log(moveContext.center.y, clickPoint.y, mousePoint.y);
      if (movedMesh) {
        if (moveContext.isRotated) {
          rotateAboutPoint(movedMesh, rotateCenter, rotateAxis, angle);

          // let angleX = moveContext.tag == "xRotateRing" ? angle : 0;
          // let angleY = moveContext.tag == "yRotateRing" ? -angle : 0;
          // let angleZ = moveContext.tag == "zRotateRing" ? angle : 0;

          let movedControlGroup = movedMesh.moveRotateGroup;
          // let boxMatrix = movedControlGroup.matrixWorld;
          // applyRotateToGingiva(); //angleX, angleY, angleZ);

          clickPoint.copy(mousePoint);
        } else {
          var pos = intersects[0].point.sub(offset);
          var point = getPointHonBC(pos, moveContext.from, moveContext.to);

          let movedGroup = movedMesh.moveRotateGroup;
          let mp = movedGroup.position; // movedMesh.position;
          let lpOffset = [point.x - mp.x, point.y - mp.y, point.z - mp.z];
          // applyRotateToGingiva();
          // applyMoveToGingiva(lpOffset);

          movedGroup.position.copy(point);
          movedMesh.position.copy(point);
          if (movedMesh.subvector) {
            movedMesh.position.sub(movedMesh.subvector);
          }
        }
        needUpdate = true;
      } else if (movedControlMesh) {
        if (moveContext.isRotated) {
          // if (moveContext.tag == "yRotateRing") {
          //   // blueRing
          //   angle = moveContext.center.y > clickPoint.y ? -angle : angle;
          //   rotateAroundAxisY(null, angle, movedControlMesh, movedControlMesh);
          // } else if (moveContext.tag == "zRotateRing") {
          //   // greenRing
          //   angle = moveContext.center.z > clickPoint.z ? angle : -angle;
          //   rotateAroundAxisZ(null, -angle, movedControlMesh, movedControlMesh);
          // } else if (moveContext.tag == "xRotateRing") {
          //   // redRing
          //   angle = moveContext.center.x > clickPoint.x ? angle : -angle;
          //   rotateAroundAxisX(null, -angle, movedControlMesh, movedControlMesh);
          // }

          // rotateAboutPoint(movedControlMesh, rotateCenter, rotateAxis, angle);
          movedControlMesh.rotateOnAxis(rotateAxis, angle);

          clickPoint.copy(mousePoint);
          // console.log("movedControlMesh R", movedControlMesh.rotation);
        } else {
          let point = intersects[0].point.sub(offset);
          // var pos = intersects[0].point.sub(offset);
          // var point = getPointHonBC(pos, moveContext.from, moveContext.to);
          movedControlMesh.position.copy(point);
        }
        needUpdate = true;
      }
    }
  }
}

function moveModeMouseUp(event, upMesh) {
  // console.clear();
  //$('#stl_cont').css('cursor', 'default');
  if (upMesh) {
    movedMesh = upMesh;
  }

  let needSelection = !movedMesh && !movedControlMesh;
  if (movedMesh) {
    applyRotateToGingiva();

    if (!vueApp.isIntraoralView) {
      findToothCollisions(moveContext.tooth);
      findToothAnchorageLoss(moveContext.tooth);
    }
  }

  if (upMesh) {
    if (upMesh.moveRotateGroup)
      upMesh.moveRotateGroup.position.copy(upMesh.position);
  } else {
    let tempMesh = null;
    if (moveContext && moveContext.id) {
      tempMesh = orthoViewer.get_model_mesh(moveContext.id);
    }

    if (tempMesh && tempMesh.moveRotateGroup) {
      tempMesh.subvector = tempMesh.moveRotateGroup.position
        .clone()
        .sub(tempMesh.position);

      tempMesh.moveRotateGroup.children.forEach((child) => {
        if (child.defaultColor) {
          child.material.color = new THREE.Color(child.defaultColor);
        }
      });
    }
  }

  orthoViewer.controls.enabled = true;
  movedMesh = movedControlMesh = null;
  if (needUpdate) {
    // redrawMoveArrow();
    vueApp.$emit("positionChanged", moveContext.tooth);
    needUpdate = false;
  }
  return needSelection;
}

function moveByTap(dx) {
  if (dx != 0) {
    var mesh = orthoViewer.get_model_mesh(moveContext.id);
    var from = mesh.position; //moveContext.from;
    var to = moveContext.to;
    var length = to.clone().sub(from).length();
    var value = dx / length;
    var newX = from.x + (to.x - from.x) * value;
    var newY = from.y + (to.y - from.y) * value;
    var newZ = from.z + (to.z - from.z) * value;
    var point = new THREE.Vector3(newX, newY, newZ);

    updateToothBeforeMove(moveContext.tooth, mesh.position, point);

    mesh.position.copy(point);
    redrawMoveArrow();
    vueApp.$emit("positionChanged", moveContext.tooth);
  }
}

function moveByTag(tag) {
  if (tag) {
    switch (tag) {
      case "from":
        moveByTap(-1);
        break;
      case "to":
        moveByTap(1);
        break;
    }
  }
}

function moveModeValueChanged(value) {
  moveContext.angle = value * Math.PI;
  redrawMoveArrow();
  // var mesh = orthoViewer.get_model_mesh(moveContext.id);
  // if (mesh) {
  // 	var from = moveContext.from;
  // 	var to = moveContext.to;
  // 	var newX = from.x + (to.x - from.x) * value;
  // 	var newY = from.y + (to.y - from.y) * value;
  // 	var newZ = from.z + (to.z - from.z) * value;
  // 	var point = new THREE.Vector3(newX, newY, newZ);
  // 	mesh.position.copy(point);
  // }
}

function changeMovePlane(isVertical) {
  moveContext.angle = moveContext.editedObject.sliderValue = 0;
  $("#movementVector").slider("value", 0);
  $("#movementVector2").slider("value", 0);
  moveContext.isVerticalPlane = isVertical;
  redrawMoveArrow();
}

export {
  enterMoveMode,
  exitMoveMode,
  moveModeMouseDown,
  moveModeMouseMove,
  moveModeMouseUp,
  moveModeValueChanged,
  redrawMoveArrow,
  moveByTap,
  moveByTag,
  changeMovePlane,
  moveModeTagDetected,
};
